<template>
  <a class="box" :href="videoItemLink(video)">
    <div class="title">{{ video.title }}</div>
    <div class="details mb-1 mt-auto">
      <div class="left-details">
        <div class="source">Alvexo</div>
        <span class="mr-1 ml-1">•</span>
        <div class="date">{{ date }}</div>
      </div>
    </div>
    <div class="img-wrapper">
      <div class="img" :style="thumbnailStyle"></div>
      <div class="video-len">{{ duration }}</div>
    </div>
  </a>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import { visualVideoDuration } from "@/utils/general";

export default {
  name: "CardWebtv",
  props: {
    video: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapState(["lang"]),
    thumbnailStyle: function() {
      // return "background-image: url('" + this.video.thumbnail_url + "');"; //the thumb image is cropped
      return "background-image: url('" + this.video.image_url + "');";
    },
    duration: function() {
      return visualVideoDuration(this.video.duration);
    },
    date: function() {
      moment.locale(this.lang);
      return moment(this.video.created_at).format("DD MMM, HH:mm");
    }
  },
  methods: {
    play(video) {
      this.$store.dispatch("webtv/play", video);
    },

    videoItemLink(item) {
      return `${location.href}/${item.temp_video_id}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.a {
  fill: #9e9e9e;
}
.b {
  fill: none;
}

.title {
  margin-bottom: 8px;
}

.description {
  display: flex;
  align-items: center;
  color: #9e9e9e;
  font-size: 14px;
  margin-top: 6px;
}

.details {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #9e9e9e;
  font-size: 12px;
  margin-top: 6px;
}

.img-wrapper {
  position: relative;
  .img {
    position: relative;
    width: 100%;
    height: 184px;
    margin: 10px auto 0;
    /* background-repeat: no-repeat; */
    /* background-position: 50%; */
    background-size: cover;
    /*background-size: contain;*/
  }

  .img:before {
    content: "";
    position: absolute;
    z-index: 1;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: url("../../assets/play.svg") no-repeat 50%;
    width: 48px;
    height: 48px;
    background-color: hsla(0, 0%, 0%, 0.65);
    border-radius: 50%;
    background-position-x: 13px;
  }

  .img:after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.35);
  }
  .video-len {
    position: absolute;
    bottom: 0;
    right: 0;
    background-color: #000000;
    color: #ffffff;
    font-size: 0.875rem;
    height: 24px;
    padding: 0 6px;
  }
}

.left-details {
  display: flex;
}
</style>
